<app-loading *ngIf="loading"></app-loading>
<div class="page-header">
    <h2 class="ts-card-title page-title">Positions</h2>
    <button class="btn-primary" type="button" [disabled]="loading" (click)="onSearch()">
        <fa-icon [icon]="faRotate"></fa-icon>
        Refresh
    </button>
</div>
<form (ngSubmit)="onSearch()">
    <div *ngIf="side == 'N' && symbol == ''" class="alert">
        <div>Symbol is required if Long/Short filter is set to 'None'.</div>
    </div>
    <div class="ts-form-field">
        <label class="ts-label">Symbol</label>
        <input class="ts-input" [(ngModel)]="symbol" name="symbol" (change)="onSearch()" type="text" [required]="side == 'N' ? true : null">
    </div>

    <div class="ts-form-field">
        <label class="ts-label">Long/Short</label>
        <select class="ts-select" [(ngModel)]="side" name="side" (change)="onSearch()">
            <option value="0">Any</option>
            <option value="L">Long</option>
            <option value="S">Short</option>
        </select>
    </div>

    <button class="btn-outlined form-button" aria-label="Reset" type="reset" (click)="onReset()"
        [disabled]="loading">Reset</button>
</form>
